var map;
var token;
var marker;
var markers = [];
var _collection_icons=["https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Seiko5_Black.png?v=1661411997","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/pressage_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/prospex_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215"];
var _allstores_list=[];
var _curr_lat=0;
var _curr_lng=0;

function GetCollectionIcons(_collections) {

  console.log('_collections 1' , _collections);

  var _res="";
  if(_collections.length>0){
    _collections.map(function(_i){
        if(_i == 1){
          var hh = 32;
        }
        else{
          var hh = 14;
        }
        _res+='<img src="'+_collection_icons[_i]+'" style="padding-top:0px;width:auto;height:'+hh+'px;display:inline-block;margin:5px 12px" />'; 
    });
  } 
  return _res; 
}

function getDistance(lat1,lon1,lat2,lon2) {
  lon2 = Number(lon2.toString().replace(/,/g, ''));
  var R = 3963.1676; // Radius of the earth in miles
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in miles
  console.log('mark2');
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

function LoaderShow() {
  $('.map_loader').show();
  $('.l_map_wrap_m').hide();
  $('.l_map_wrap_modal').css({'visibility':'visible','opacity':'1'});
}

function LoaderHide() {
  $('.map_loader').hide();	
  $('.l_map_wrap_modal').css({'opacity':'0','visibility':'hidden'});
}

function PopuperShow(test) {
  $('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 300, function(){
    if(window.innerWidth > 640){
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '90px' }, 600);	
    }
    else{
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '60px' }, 600);	
    }
  });
}

// function L_GeoIP(){
// 	    $.getJSON("https://geoip-db.com/json/").success(function(data) {
//         	if(data.country_code!="US"){
//               	LoaderShow();
//               	searchLocationsNear(40.7394322, -73.9988017, function(){
//               		PopuperShow("No locations were found using your search criteria [ <b>"+(data.country_name || 'Your location')+"</b> ]. Please try another input address to search for locations.");
// 				});
// 			} else{
// 				searchLocationsNear(parseFloat(data.latitude),parseFloat(data.longitude));
// 			}
//         }).error(function() {
//           	  LoaderShow();
//               searchLocationsNear(40.7394322, -73.9988017, function(){
//                   PopuperShow("No locations were found using your search criteria [Your location]. Please try another input address to search for locations."); 
//               });
//         });
// }

function L_GeoIP() {
    $.getJSON("https://geoip-db.com/json/")
        .done(function (data) {

            if (data.country_code !== "US") {
                LoaderShow();
                searchLocationsNear(40.7394322, -73.9988017, "", function () {
                    PopuperShow(
                        "No locations were found using your search criteria [ <b>" +
                        (data.country_name || 'Your location') +
                        "</b> ]. Please try another input address to search for locations."
                    );
                });
            } else {
                searchLocationsNear(
                    parseFloat(data.latitude),
                    parseFloat(data.longitude)
                );
               
            }

        })
        .fail(function () {
            LoaderShow();
            searchLocationsNear(40.7394322, -73.9988017, "", function () {
                PopuperShow(
                    "No locations were found using your search criteria [Your location]. Please try another input address to search for locations."
                );
            });
        });
}


function L_GeoIPFirstOpen(){
  LoaderShow();
  clearLocations();
  markers = [];

  map.setView([41.07948863511428, -74.16179180145265], 13);
 
  var id = "5d13c0f07e64391100b2090c";
  var store_name = "Seiko Corporation of America";
  var phone = "+1 201-529-5730";
  var site = "seikousa.com";
  var address = "1111 MacArthur Blvd, Mahwah, NJ 07430, USA";
  var latl = "41.07948863511428";
  var lngl = "-74.16179180145265";
  var _collections="";
  var distance = getDistance(41.07948863511428, -74.16179180145265, latl, lngl).toFixed(1);
console.log('mark3', distance);
  createMarker(id, store_name, phone, address, latl, lngl, 0, distance, site, _collections);
  
  LoaderHide();
  centerMarkers();

  
}

function clearLocations() {
	$(".l_map_res_list").empty();
    markers.map(function(_i){
       map.removeLayer(_i);
    });
}

// function searchLocations() {
//     var address = ($('#praddress').val().length > 0 
//         ? $('#praddress').val().trim().replace(/ /g, '+') 
//         : "");

//     if (address.length > 2) {
//         $.getJSON('https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=YOUR_GOOGLE_API_KEY', function(response) {
//             if (response.status === "OK" && response.results[0]) {
//                 var location = response.results[0].geometry.location;
//                 searchLocationsNear(location.lat, location.lng);
//             } else {
//                 LoaderShow();
//                 PopuperShow("No locations were found using address.");
//             }
//         });
//     } else {
//         LoaderShow();
//         PopuperShow("Please enter an address.");
//     }
//     return false;
// }


function searchLocations() {
	var address =($('#praddress').val().length>0 ? $('#praddress').val().trim().replace(/ /g,'+')+'+' : "");
	
	if(address.length>2){
		$.getJSON('https://geocode.maps.co/search?q='+address+'&api_key=658c72e030653798329319cwx861442', function(_locs) {    
		if (_locs) {
			if (_locs[0]) {
				searchLocationsNear(parseFloat(_locs[0].lat),parseFloat(_locs[0].lon));
			} else {
              	LoaderShow();
				PopuperShow("No locations were found using address.");
			}
		} else {
          	LoaderShow();	
			PopuperShow("No locations were found using address.");
		}
		});
	}else{
      	LoaderShow();	
		PopuperShow("Please enter an address.");
	}
	return false;
}

function centerMarkers() {
	var group = L.featureGroup(markers);
	map.fitBounds(group.getBounds());
}

function searchLocationsNear(lat, lng, name, callbackFnk, onlyMap = false) {  
    LoaderShow();
    showLoader();
    $(".list_loader_popup").show();
    clearLocations();
    markers = []; 

    var searchUrl = null;
    if (typeof name !== 'undefined' && name !== null && name !== '') {
        searchUrl = 'https://skus.gatewayforge.io/public/api/store-locator?search_name=' + name + '&per_page=1';
    } else {
        searchUrl = 'https://skus.gatewayforge.io/public/api/store-locator?latitude=' + lat + '&longitude=' + lng + '&per_page=1';
    }

    var _data = {};

    // REMOVE these lines:
    // _data["storeid"]  = lng;
    // lat = 0;
    // lng = 0;

    // Instead, preserve lat/lng:
    if (lat && lng) {
        _curr_lat = lat;
        _curr_lng = lng;
    }

    $('.collections_filter_s li').removeClass('active');

  
   _curr_lat=lat;
   _curr_lng=lng;

	PostRec(searchUrl, _data, function(_err, __data){
   	    if (__data.stores.length > 0) {
   	    	var ___data = __data['stores'];
			_allstores_list=___data;
          
   	    	if(___data.length>0){
				
				map.setView([lat, lng], 13);
				$('.l_map_wrap_right').css('opacity', '1');
              
              if(onlyMap===false){
               	   var _all_strs=[];
                
                  for (var i = 0; i < ___data.length; i++) {
                      var id 			= ___data[i]._id;
                      var store_name 	= ___data[i].data.name;
                      var phone 		= ___data[i].data.phone;
                      var site 		= ___data[i].data.web;
                      var address 	= ___data[i].data.address;
                      var city_state 	= _allstores_list[i].data.city_state;
                      var latl 		= ___data[i].position[1];
                      var lngl 		= ___data[i].position[0];
                      var distance 	= getDistance(lat, lng, latl, lngl).toFixed(1);
                      var _collection =GetCollectionIcons(___data[i].collections);
console.log('mark5');
                    _all_strs.push({id:id, store_name:store_name, phone:phone, address:address, city_state:city_state, latl:latl, lngl:lngl, distance:distance, i:i, collection:_collection, site:site});
                  }
                
               	 _all_strs.sort(SortStores);
                
                 for (var i = 0; i < _all_strs.length; i++) {
               		 createOption(_all_strs[i].id, _all_strs[i].store_name, _all_strs[i].phone, _all_strs[i].address, _all_strs[i].city_state, _all_strs[i].latl, _all_strs[i].lngl, _all_strs[i].distance, i, _all_strs[i].collection, _all_strs[i].site); // Pass i as marker index
	         	 	      createMarker(_all_strs[i].id, _all_strs[i].store_name, _all_strs[i].phone, _all_strs[i].address, _all_strs[i].latl, _all_strs[i].lngl, i, _all_strs[i].distance, _all_strs[i].site, _all_strs[i].collection); // Pass i as marker index
                 }
                
                $('.current_location.mobile_new').hide();
              
                // if($(window).width()>920){ 
                //   $(".l_map_wrap_left_scrl").mCustomScrollbar("update");
                // }
              }
              else{
                $('.l_map_wrap_right').css('opacity', '.4');
              	LoaderHide();
              }
              
                if(typeof callbackFnk == 'function'){
                  callbackFnk.call();
                }
                else{
                  LoaderHide();
                }
			} else{
        hideLoader();
					searchLocationsNear(40.7394322, -73.9988017, function(){
                		PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");
					});
			}
			
			if(markers.length){	
				centerMarkers();
			}
		}
      else {
        clearLocations();
        hideLoader();
        PopuperShow("Please search another input address to search for locations.");
      }
     });	
}

// function createMobilePopup(store_name, address, phone, site, _collection, lat, lng, distance){
// 	return ('<div class="mob_popup"><h2>'+store_name+'</h2><h1>'+address+'</h1><p class="l_map_phone"><span><a style="text-decoration:none" href="tel:'+phone.replace(/ /g, '').replace(/-/g, '')+'">'+phone+'</a></span>'+(typeof site !='undefined' ?  (site!='' ? '<span><a target="_blank" href="'+site.toLowerCase()+'">View Website</a></span>' : ''):'')+(_collection!="" ? "<div class=\"leaf_col\">" + _collection+"</div>" : "")+'</p><a class="standard_button white border" href="https://www.google.com/maps/dir/Current+Location/'+lat+','+lng+'/" target="_blank">GET DIRECTIONS</a><p class="l_map_distance">'+distance+' mi</p><a href="#" class="popup_close mob_popup_close fr" title="close" aria-label="close shop findstore popup">close</a></div>');
// }

function createMobilePopup(store_name, address, phone, site, _collection, lat, lng, distance){

  console.log('lsls', store_name, address, phone, site, _collection, lat, lng, distance);

    var safeSite = '';

    if (typeof site === 'string' && site.trim() !== '') {
        safeSite = site.toLowerCase();
    }

    return (
        '<div class="mob_popup">' +
            '<h2>' + store_name + '</h2>' +
            '<h1>' + address + '</h1>' +
            '<p class="l_map_phone">' +
                '<span>' +
                    '<a style="text-decoration:none" href="tel:' + phone.replace(/ /g, '').replace(/-/g, '') + '">' + phone + '</a>' +
                '</span>' +

                (safeSite
                    ? '<span style="margin-top:5px;"><a target="_blank" href="' + safeSite + '">View Website</a></span>'
                    : ''
                ) +

                (_collection !== "" 
                    ? '<div class="leaf_col">' + _collection + '</div>' 
                    : ''
                ) +
            '</p>' +

            '<a class="standard_button border" href="https://www.google.com/maps/dir/Current+Location/' + lat + ',' + lng + '/" target="_blank">GET DIRECTIONS</a>' +
            '<p class="l_map_distance">' + distance + ' mi</p>' +
            '<a href="#" class="popup_close mob_popup_close fr" title="close" aria-label="close shop findstore popup">close</a>' +
        '</div>'
    );
}

function createOption(id, store_name, phone, address, city_state, lat, lng, distance, markerIndex, _collection, site) {	

  	$('.l_map_wrap_left_wrap').css('width', '100%');
  	
    if(window.innerWidth < 640){
      $('.store_form .standard_title').hide();
      $(".l_map_res_list").append(
          "<li class='l_map_res_list_i' tabindex='0' id='store_"+id+"' data-marker-index='"+markerIndex+"' "+
              "data-name=\""+store_name.trim()+"\" " +
              "data-address=\""+address.trim()+"\" " +
        	  "data-distance='"+distance.trim()+"' " +
        	  "data-collection='"+_collection.trim()+"' " +
              "data-phone='"+phone.trim()+"' data-storeid='listelement_"+markerIndex+"' data-ind='"+id+"' " +  
              "data-lat='"+lat+"' data-lng='"+lng+"'> " +
                  "<span class='l_map_store_name'>" + store_name.trim() + "</span>" +
                  "<p class='l_map_distance'>" + distance +" mi<span class='l_map_address'>" + city_state.trim()+"</span></p>" +
        		"<img class='map_info_img' src='https://cdn.shopify.com/s/files/1/0019/1433/9446/t/7/assets/info_map.svg?v=1594814802' />"+ 
        "</li>");
    }
  	else{
      $(".l_map_res_list").append(
          "<li class='l_map_res_list_i' tabindex='0' id='store_"+id+"' data-marker-index='"+markerIndex+"' "+
              "data-name='"+store_name.trim()+"' " +
              "data-address='"+address.trim()+"' " +
              "data-phone='"+phone.trim()+"' data-storeid='listelement_"+markerIndex+"' data-ind='"+id+"' " +  
              "data-lat='"+lat+"' data-lng='"+lng+"'> " +
                  "<span class='l_map_store_name'>" + store_name.trim() + "</span>" +
                  "<p class='l_map_distance'>" + distance +" mi</p>" +
                  "<p class='l_map_address'>" + address.trim()+"</p>" +
          "</li>");
    }
}

function createMarker(id, store_name, phone, address, lat, lng, markerIndex, distance, site, _collection) {

    lng = Number(lng.toString().replace(/,/g, ''));

    marker = new L.marker([lat, lng]).addTo(map);

    // Store the marker index in the marker object for reference
    marker.markerIndex = markerIndex;
    marker.storeId = id;

    marker.on("click", function (event) {
        markerOnClick(this.markerIndex, lat, lng);
    });

    markers.push(marker);

    /* ---------- SAFE SITE ---------- */
    var safeSite = '';
    if (typeof site === 'string' && site.trim() !== '') {
        safeSite = site.toLowerCase();
    }

    // console.log('_collection', _collection);

    var popupHtml =
        '<h2>' + store_name + '</h2>' +
        '<h1>' + address + '</h1>' +
        '<p class="l_map_phone">' +
            '<span>' +
                '<a style="text-decoration:none" href="tel:' + phone.replace(/ /g, '').replace(/-/g, '') + '">' + phone + '</a>' +
            '</span>' +

            (safeSite
                ? '<span><a target="_blank" href="' + safeSite + '">View Website</a></span>'
                : ''
            ) +

            (_collection !== ""
                ? '<div class="leaf_col">' + _collection + '</div>'
                : ''
            ) +
        '</p>' +

        '<a class="standard_button white border" href="https://www.google.com/maps/dir/Current+Location/' + lat + ',' + lng + '/" target="_blank">GET DIRECTIONS</a>' +
        '<p class="l_map_distance">' + distance + ' mi</p>';

    marker.bindPopup(popupHtml, {
        maxWidth: 600
    });
}


function markerOnClick(markerIndex, lat, lng) {
    centerLeafletMapOnMarker(lat, lng, 16);
    
	$('.l_map_res_list_i').removeClass('selected');
	$('.l_map_res_list_i[data-storeid="listelement_'+markerIndex+'"]').addClass('selected');
  const $el = $('.l_map_res_list_i[data-storeid="listelement_'+markerIndex+'"]');
  $el.addClass('selected');
  // native smooth scroll
  $el[0].scrollIntoView({ behavior: "smooth", block: "nearest" });

	// $(".l_map_wrap_left_scrl").mCustomScrollbar("scrollTo", '.l_map_res_list_i[data-storeid="listelement_'+markerIndex+'"]');
}

function centerLeafletMapOnMarker(lat, lng, zoom) {
  lng = Number(lng.toString().replace(/,/g, ''));
	map.flyTo([lat, lng], zoom);
}

function get_all_addresses(_data){
  var _allpr=[];
  var _ind=0;
  _data.map(function(_k,_c){
    if(_ind<3 && (_k.display_name.indexOf(', USA')>0 || _k.display_name.indexOf(', Guam')>0 || _k.display_name.indexOf(', United States')>0 || _k.display_name==$('#praddress').val())){
      var _address=_k.display_name.replace(/, United States of America/g,'');
      if(_address.indexOf('County')>0){
        var _tmm=_address.split(',');
        var _new_addr=[];
        _tmm.map(function(_t){
          if(_t.indexOf('County')==-1) _new_addr.push(_t.trim());
        });
        _address=_new_addr.join(', ');
      }
    	_allpr.push({"id":_c+2, "title":_address, "lat":_k.lat, "lon":_k.lon});
      _ind++;
    }
  });
  return _allpr;
}

  let COLLECTION_ID_MAP = {};   // dynamic now

  function Map_filter_result(){
    var _all_filters = [];

    $(".collections_filter_s li").each(function(){
      if($(this).hasClass('active')) {
          let uiId = parseInt($(this).attr('data-id'));
          let realId = COLLECTION_ID_MAP[uiId];

          if(realId){
              _all_filters.push(realId);
          } else {
            // $(this).hide();
            _all_filters.push(9999); // no id was found
            console.warn('No mapping for UI filter id:', uiId);
          }
      }
    });

    console.log('Active Filters:', _all_filters);

    $(".l_map_res_list").empty();

    // remove old markers
    // console.log('Removing old markers:', markers.length);
    markers.map(function(_i){
        map.removeLayer(_i);
    });
    markers = [];

    var _ind = 0;
    var _all_strs = [];

    // console.log('Stores Loaded:', _allstores_list.length);
    // console.table(_allstores_list.map(s => ({
    //     id: s.id,
    //     name: s.store_name,
    //     city: s.city_state
    // })));

    for (var i = 0; i < _allstores_list.length; i++) {

        var store = _allstores_list[i];
        // console.group('Store:', store.store_name, '| ID:', store.id);

        var _filters = (store.collections || []);
        // console.log('Store Collections:', _filters);

        var _showitem = false;

        /* ---------- FILTER LOGIC ---------- */
        if (_all_filters.length > 0 && _filters.length > 0) {

            // extract collection IDs
            var storeCollectionIds = _filters.map(c => parseInt(c.id));
            // console.log('Store Collection IDs:', storeCollectionIds);

            var matched = 0;
            for (var j = 0; j < _all_filters.length; j++) {
              if (storeCollectionIds.includes(_all_filters[j])) {
                    matched++;
                    // console.log('Matched Filter:', _all_filters[j]);
                } else {
                    // console.log('Blocked by Filter:', _all_filters[j]);
                }
            }

            if (matched === _all_filters.length) {
                _showitem = true;
                // console.log('STATUS: SHOW (all filters matched)');
            } else {
                // console.log('STATUS: BLOCKED (not all filters matched)');
            }

        } else if (_all_filters.length === 0) {
            _showitem = true;
            // console.log('STATUS: SHOW (no active filters)');
        } else {
            // console.log('STATUS: BLOCKED (filters active but store has no collections)');
        }

        /* ---------- DATA MAPPING ---------- */
        if (_showitem){

            var id          = store.id;
            var store_name  = store.store_name;
            var phone       = store.phone_number;
            var site        = store.website;
            var address     = store.address;
            var city_state  = store.city_state;

            var latl        = parseFloat(store.latitude);
            var lngl        = parseFloat(store.longitude);

            var distance    = getDistance(_curr_lat, _curr_lng, latl, lngl).toFixed(1);
console.log('kk',distance);
            var _collection = GetCollectionIcons(store.collections || []);

            // console.log('Mapped Data:', {
            //     id, store_name, phone, site, address, city_state, latl, lngl, distance
            // });

            _all_strs.push({
                id: id,
                store_name: store_name,
                phone: phone,
                address: address,
                city_state: city_state,
                latl: latl,
                lngl: lngl,
                distance: distance,
                i: _ind,
                collection: _collection,
                site: site
            });

            // console.log('PUSHED → index:', _ind);
            _ind++;
        }

        // console.groupEnd();
    }

    /* ---------- SORT ---------- */
    // console.log('Sorting stores by distance...');
    _all_strs.sort(SortStores);

    // console.log('Final Stores Count:', _all_strs.length);
    // console.table(_all_strs.map(s => ({
    //     id: s.id,
    //     name: s.store_name,
    //     distance: s.distance
    // })));

    /* ---------- RENDER ---------- */
    for (var i = 0; i < _all_strs.length; i++) {

      // console.log('Render Store:', _all_strs[i].store_name, '| index:', i);

        createOption(
            _all_strs[i].id,
            _all_strs[i].store_name,
            _all_strs[i].phone,
            _all_strs[i].address,
            _all_strs[i].city_state,
            _all_strs[i].latl,
            _all_strs[i].lngl,
            _all_strs[i].distance,
            i,
            _all_strs[i].collection,
            _all_strs[i].site
        );
        
        createMarker(
            _all_strs[i].id,
            _all_strs[i].store_name,
            _all_strs[i].phone,
            _all_strs[i].address,
            _all_strs[i].latl,
            _all_strs[i].lngl,
            i,
            _all_strs[i].distance,
            _all_strs[i].site,
            _all_strs[i].collection
        );
    }

    if(markers.length > 0){
      // console.log('Centering markers...');
        centerMarkers();
    }

    // New (optional: scroll first selected item into view)
    const $first = $(".l_map_res_list_i.selected").first();
    if ($first.length) {
        $first[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    // $(".l_map_wrap_left_scrl").mCustomScrollbar("update");
  }


  $(document).ready(function(e) {
  
    if($('.store_form').length){

      if(!$('.l_map_res_list_i').length){
        $('.store_form .standard_title').show();
          }
          else{
            $('.current_location.mobile_new').hide();
          }
        }
    
    $('.collections_filter_s li').on('click', function(){
      // console.log('collection_clcik');
      if($(this).hasClass('active')){
          $(this).removeClass('active');
      } else {
         $(this).addClass('active');
      }      
     	Map_filter_result();
    });
    
    $('.current_location').on('click keypress', function(){           	
      $(".l_map_res_list").empty();      
      L_GeoIP();      
    });

	$('#praddress').keypress(function (e) {
	  if (e.which == 13) {
		// searchLocations(); 
	  }
	});		

	$("body").on('click', '.address_search', function(e) {
		e.preventDefault(); 
		searchLocations();

	});

	$('body').on('click', '.l_map_wrap_o, .l_map_wrap_close', function(e) {
		e.preventDefault();
		$('.l_map_wrap_modal').css({'opacity':'0','visibility':'hidden'});
		return false;
	});

	// if($(".l_map_wrap_left_scrl").length){
	// 	$(".l_map_wrap_left_scrl").mCustomScrollbar({
	// 		axis:"y",
	// 		theme:"dark"
	// 	});
	// }

  if ($(".l_map_wrap_left_scrl").length) {
    // Enable native vertical scrolling
    $(".l_map_wrap_left_scrl").css({
        "overflow-y": "auto",
        "max-height": "880px", // set the height you want the scroll area to be
        "scrollbar-width": "none", // for Firefox
            "-ms-overflow-style": "none"
    });

    $(".l_map_wrap_left_scrl").css({
            "::-webkit-scrollbar": "display: none"
        });
  }
    
  let typingTimer;
  const doneTypingInterval = 500; // 0.5 seconds

$("#praddress").on('keyup', function () {
    clearTimeout(typingTimer);

    typingTimer = setTimeout(function () {
        var _data = $("#praddress").val();
        const selectedValue = $('input[name="search_type"]:checked').val();

        if (_data.length > 2) {
          showLoader();
            PostRec('https://geocode.maps.co/search?q=' + _data + '&countrycodes=us&format=json&api_key=658c72e030653798329319cwx861442', _data, function (_err, ___data) {
                if (selectedValue == 'location') {
                    var addresses_drop = (___data ? get_all_addresses(___data) : []);
                    $('.addresses_drop').html('');
                    if (addresses_drop.length) {
                        for (var _a = 0; _a < addresses_drop.length; _a++) {
                            $('.store_form').addClass('opened');
                            $('.addresses_drop').addClass('opened').append(
                                "<li class='l_drop_li' data-id='" + addresses_drop[_a]['id'] + "' " +
                                "data-name='" + addresses_drop[_a]['title'].trim() + "' " +
                                "data-address='" + addresses_drop[_a]['title'].trim() + "' " +
                                "data-lat='" + addresses_drop[_a]['lat'] + "' data-lng='" + addresses_drop[_a]['lon'] + "'>" +
                                addresses_drop[_a]['title'] + "</li>"
                            );
                        }

                        hideLoader();
                    } else {
                        $('.store_form').addClass('opened');
                        $('.addresses_drop').addClass('opened').append("<li>No address found.</li>");
                    }
                } else if (selectedValue === 'name') {
                  showLoader();
                    $('.store_form').addClass('opened');
                    // console.log('name', _data);
                    searchLocationsNear("", "", _data);
                }
            });
        }
    }, doneTypingInterval);
});

// $("#praddress").on('keyup', function () {
//     clearTimeout(typingTimer);

//     typingTimer = setTimeout(function () {
//         var _data = $("#praddress").val();
//         const selectedValue = $('input[name="search_type"]:checked').val();

//         console.log("User typed:", _data, "Search type:", selectedValue);

//         if (_data.length > 2) {
//             PostRec(
//                 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(_data) + '&key=658c72e030653798329319cwx861442',
//                 _data,
//                 function (_err, ___data) {
//                     console.log("Raw response:", ___data);
                    
//                     if (selectedValue == 'location') {
//                       console.log("selectedValue:", selectedValue, "___data", ___data);

//                         var addresses_drop = [];
//                         if (___data && ___data.status === "OK" && ___data.results.length) {
//                             console.log("Found", ___data.results.length, "results");
//                             for (var i = 0; i < ___data.results.length; i++) {
//                                 var result = ___data.results[i];
//                                 var loc = result.geometry.location;
//                                 console.log("Result", i, ":", result.formatted_address, loc);

//                                 addresses_drop.push({
//                                     id: i,
//                                     title: result.formatted_address,
//                                     lat: loc.lat,
//                                     lon: loc.lng
//                                 });
//                             }
//                         } else {
//                             console.warn("No valid results. Status:", ___data ? ___data.status : "No data");
//                         }

//                         $('.addresses_drop').html('');
//                         if (addresses_drop.length) {
//                             for (var _a = 0; _a < addresses_drop.length; _a++) {
//                                 console.log("Appending address:", addresses_drop[_a]);
//                                 $('.store_form').addClass('opened');
//                                 $('.addresses_drop').addClass('opened').append(
//                                     "<li class='l_drop_li' data-id='" + addresses_drop[_a]['id'] + "' " +
//                                     "data-name='" + addresses_drop[_a]['title'].trim() + "' " +
//                                     "data-address='" + addresses_drop[_a]['title'].trim() + "' " +
//                                     "data-lat='" + addresses_drop[_a]['lat'] + "' data-lng='" + addresses_drop[_a]['lon'] + "'>" +
//                                     addresses_drop[_a]['title'] + "</li>"
//                                 );
//                             }
//                         } else {
//                             console.log("No addresses to append");
//                             $('.store_form').addClass('opened');
//                             $('.addresses_drop').addClass('opened').append("<li>No address found.</li>");
//                         }
//                     } 
//                     else if (selectedValue === 'name') {
//                         console.log("Search type is 'name', calling searchLocationsNear with:", _data);
//                         $('.store_form').addClass('opened');
//                         searchLocationsNear("", "", _data);
//                     }
//                 }
//             );
//         } else {
//             console.log("Input too short, skipping request");
//         }
//     }, doneTypingInterval);
// });

$("#praddress").on('keydown', function () {
    clearTimeout(typingTimer);
});
    
    $('body').on('click keypress', '.mob_popup_close', function(e) {
      $('.mobile_pin_popup').html('').hide();
      $('body').css('overflow', 'inherit');
    });

    $('body').on('click keypress', '.l_map_res_list_i', function(e) {

          if($(e.target).attr('class') == 'map_info_img'){
            e.preventDefault();
            $('html, body').animate({
              scrollTop: 0
            });
            var mobile_pin_popup_info = createMobilePopup($(this).attr('data-name'), $(this).attr('data-address'), $(this).attr('data-phone'), $(this).attr('data-site'), $(this).attr('data-collection'), $(this).attr('data-lat'), $(this).attr('data-lng'), $(this).attr('data-distance'));
            $('.mobile_pin_popup').css('height', window.innerHeight-54).html(mobile_pin_popup_info).show();
            $('body').css('overflow', 'hidden');
            $('.l_map_res_list_i').removeClass('selected');
            $(this).addClass('selected');
          }
          else{
            // Use data-marker-index instead of data-id for correct marker reference
            var markerIndex = parseInt($(this).attr('data-marker-index'));

            if (markers[markerIndex]) {

                markers[markerIndex].openPopup();
                $('.leaflet-marker-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon.png');
                $('.leaflet-marker-icon').eq(markerIndex).attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon-black.png');
                $('.l_map_res_list_i').removeClass('selected');
                $(this).addClass('selected');	
                centerLeafletMapOnMarker($(this).attr('data-lat'), $(this).attr('data-lng'), 16);
                if(window.innerWidth < 640){
                  $('html, body').animate({
                    scrollTop: ($(".l_map_wrap_right").offset().top-100)
                  }, 2000);
                }
            }
          }
    });

  	$('body').on('click', '.l_drop_li', function(e) {
      	$('.store_form').removeClass('opened');
      	$('.addresses_drop').removeClass('opened').html('');
      	$('#praddress').val($(this).data('address'));
     	 searchLocationsNear(parseFloat($(this).data('lat')),parseFloat($(this).data('lng')));
	  });
  
  	$('body').on('click', '.store_form.opened .form_block button.close_search', function(e){
      	e.preventDefault();
  		$('.store_form').removeClass('opened');
      	$('.addresses_drop').removeClass('opened').html('');
        $('#praddress').val('');
      return false;
  	});
  
  	$('body').on('click', '.leaflet-marker-icon', function(e){
		$('.leaflet-marker-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon.png');
  		$(this).attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon-black.png');
  	});

  	if($('#mapid').length || $('#mapid_mobile').length){
  
      token = 'pk.eyJ1IjoiYXJha3MiLCJhIjoiY2prdXVid21mMGl3YjN2cW5oNjV0b2hyZSJ9.ruwlUiU1KHzzL7jCLgJxnA';
      if(window.innerWidth > 640){
      	map = L.map('mapid');
      }
      else{
      	map = L.map('mapid_mobile');
      }

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
         maxZoom: 18,
         attribution: 'Map data &copy; '
      }).addTo(map);

      var _hashed=window.location.hash.replace('#','').trim();
      var _hashelements=_hashed.split("|");
      
      if(_hashelements.length==3){
        $('.list_loader_popup').show();
       
         _curr_lat=_hashelements[1];
		    _curr_lng=_hashelements[2];
        
        setTimeout(function(){ 
            searchLocationsNear(_curr_lat, _curr_lng, function(){
              if($('#store_'+_hashelements[0])[0]) 
               $('#store_'+_hashelements[0]).trigger('click');
            });
        }, 100);
        
        setTimeout(function(){ 
        	$('.list_loader_popup').hide();
        }, 2500);
      } 
      else {
        $('.list_loader_popup').hide();
      	setTimeout(function(){ L_GeoIPFirstOpen(); },100);
      }
    }
});

////////////////////////////////////////////////////////////////////////////////
function SortStores( a, b ) {
  if ( parseFloat(a.distance) < parseFloat(b.distance) ){
    return -1;
  }
  if ( parseFloat(a.distance) > parseFloat(b.distance) ){
    return 1;
  }
  return 0;
}

// PostRec function - add this if it's missing from your code
// function PostRec(url, data, callback) {
//     $.ajax({
//         url: url,
//         type: 'POST',
//         data: JSON.stringify(data),
//         contentType: 'application/json',
//         success: function(response) {
//             callback(null, response);
//         },
//         error: function(xhr, status, error) {
//             callback(error, null);
//         }
//     });
// }

function PostRec(url, data, callback) {
    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        // data: JSON.stringify(data),
        success: function(response) {
            callback(null, response);
        },
        error: function(xhr, status, error) {
            callback(error, null);
        }
    });
}

// from main.js
//////////////////////////////////////////////////////////////////////////
var _collections_list_for_store_locator=["", "seiko5sports", "presage", "prospex"];

function get_all_addresses_popup(_data){
  var _allpr=[];
  var _ind=0;
  _data.map(function(_k,_c){
    if(_ind<3 && (_k.display_name.indexOf(', USA')>0 || _k.display_name.indexOf(', United States')>0)){
      var _address=_k.display_name.replace(/, United States of America/g,'');
      if(_address.indexOf('County')>0){
        var _tmm=_address.split(',');
        var _new_addr=[];
        _tmm.map(function(_t){
          if(_t.indexOf('County')==-1) _new_addr.push(_t.trim());
        });
        _address=_new_addr.join(', ');
      }
    	_allpr.push({"id":_c+2, "title":_address, "lat":_k.lat, "lon":_k.lon});
      _ind++;
    }
  });
  return _allpr;
}

////////////////////////////////////////////////////////////////////////////////
function searchLocations_inpopup() {
   $(".l_map_res_list").empty();
   $('.list_loader_popup').show();
	var address =($('#praddress_incollection').val().length>0 ? $('#praddress_incollection').val().trim().replace(/ /g,'+')+'+' : "");
		
	if(address.length>1){
		$.getJSON('https://geocode.maps.co/search?q='+address+'&format=json&polygon=1&addressdetails=1&api_key=658c72e030653798329319cwx861442', function(_locs) {    
		if (_locs) {
			if (_locs[0]) {
				searchLocationsNear_popup(parseFloat(_locs[0].lat),parseFloat(_locs[0].lon));
			} else {
                $('.list_loader_popup').hide();
				PopuperShow("No locations were found using address.");
			}
		} else {
            $('.list_loader_popup').hide();
			PopuperShow("No locations were found using address.");
		}
		});
	}else{
       $('.list_loader_popup').hide();
		PopuperShow("Please enter an address.");
	}
	return false;
}

////////////////////////////////////////////////////////////////////////////////
function SortStores( a, b ) {
  if ( parseFloat(a.distance) < parseFloat(b.distance) ){
    return -1;
  }
  if ( parseFloat(a.distance) > parseFloat(b.distance) ){
    return 1;
  }
  return 0;
}

////////////////////////////////////////////////////////////////////////////////

function searchLocationsNear_popup(lat, lng) {
  	_curr_lat=lat;
 	_curr_lng=lng;
	var searchUrl = 'https://skus.gatewayforge.io/api/store-locator';
	var _data={};
    _data["latitude"]   = lat;
    _data["longitude"]  = lng;
    
  var _other_coll=true;
  var _curr_coll=-1;
  if(typeof _collection_handle !='undefined'){
    if(_collection_handle!=''){
      if(_collections_list_for_store_locator.indexOf(_collection_handle)>-1) {
        _other_coll=false;
        _curr_coll=_collections_list_for_store_locator.indexOf(_collection_handle);
        _data["collection"]=_curr_coll;
      }
    }
  }
  $(".l_map_res_list").empty();
  	
	
	PostRec(searchUrl, _data, function(_err, __data){
   	    if(!_err){
   	    	___data = __data['stores'];
          
          	var _itmss=[];
           $('.list_loader_popup').hide();
   	    	if(___data.length>0){
	   	    	for (var i = 0; i < ___data.length; i++) {
                  if(_other_coll || (!_other_coll && ___data[i].collections.indexOf(_curr_coll)>-1)){
                    _itmss.push({id:___data[i]._id,name:___data[i].data.name, address:___data[i].data.city_state,latl:___data[i].position[1],lngl:___data[i].position[0],distance:getDistance_popup(lat, lng, ___data[i].position[1], ___data[i].position[0]).toFixed(1)}); 
                  }
				}
              if(_itmss.length>0){
                _itmss.sort(SortStores);
                
                  if(window.innerWidth > 640){
                    for (var i = 0; i < 3; i++) {
                         createOption_popup(_itmss[i].id,_itmss[i].name,  _itmss[i].address, _itmss[i].latl, _itmss[i].lngl, _itmss[i].distance, i);
                    }  
                  }
                  else{
					for (var i = 0; i < 2; i++) {
                         createOption_popup(_itmss[i].id,_itmss[i].name,  _itmss[i].address, _itmss[i].latl, _itmss[i].lngl, _itmss[i].distance, i);
                    }  
                  }
                  // $(".l_map_res_list").append('<a class="view_more_s" href="/pages/store-locator#'+_itmss[0].id+"|"+_curr_lat+"|"+_curr_lng+'">View all results</a>');
                
             	 var ul_height = $('.find_a_store_opened .l_map_res_list').height();
             	 $('.find_a_store_opened').stop().animate({"height": ul_height - 105}, 400);
             	 $('.find_a_store_opened .l_map_wrap_left_scrl').stop().animate({"height": ul_height+50}, 400);
              } else{
                  $('.find_a_store_opened').stop().animate({"height": 250}, 400);
                  PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");	
              }
			} else{
                $('.find_a_store_opened').stop().animate({"height": 250}, 400);
				PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");	
			}
		} 
		
     });	
}

function createOption_popup(id, store_name,  address, lat, lng, distance, i) {	
  showLoader();
  	PopuperClose();
  	$('.store_popup_block h2 span').hide();
	$(".l_map_res_list").append(
      "<li class='l_map_res_list_i' tabindex='0' data-id='"+i+"'  "+
          "data-name='"+store_name.trim()+"' " +
          "data-address='"+address.trim()+"' " +

          "data-lat='"+lat+"' data-lng='"+lng+"'> " +
          "<a href='/pages/store-locator#"+id+"|"+_curr_lat+"|"+_curr_lng+"'><span class='l_map_store_name'>" + store_name.trim() + "</span>" +
          "<p class='l_map_distance'>" + distance +" mi<span class='l_map_address'>" + address.trim()+"</span></p>" +
          "</a>" +
      "</li>");
}


function getDistance_popup(lat1,lon1,lat2,lon2) {
  var R = 3963.1676; // Radius of the earth in miles
  var dLat = deg2rad_popup(lat2-lat1);  // deg2rad below
  var dLon = deg2rad_popup(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad_popup(lat1)) * Math.cos(deg2rad_popup(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in miles
  
  return d;
}

function deg2rad_popup(deg) {
  return deg * (Math.PI/180)
}


function L_GeoIP_popup(){
  $.getJSON("https://geoip-db.com/json/").success(function(data) {
    if(data.country_code!="US"){
      hideLoader();
        PopuperShow("No locations were found using your search criteria [ <b>"+(data.country_name || 'Your location')+"</b> ]. Please try another input address to search for locations."); 
    } else{
       $('.list_loader_popup').show();
       searchLocationsNear_popup(parseFloat(data.latitude),parseFloat(data.longitude));
    }
  }).error(function() {
    hideLoader();
      PopuperShow("No locations were found using your search criteria [Your location]. Please try another input address to search for locations."); 
  });
}


function PopuperShow(test) {
  $('.store_popup_block h2 span').show();
  $('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 300, function(){
    if(window.innerWidth > 640){
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '70px' }, 600);
      	$('.find_a_store_opened').stop().animate({"height": 260}, 400);
    }
    else{
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '60px' }, 600);	
    }
  });
  
  setTimeout(function(){
  	$('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 600);
  }, 3000);
}
       
function PopuperClose(test) {	
  $('#l_map_wrap_m_text').html(test).animate({ opacity: 0, height: 0 }, 600);	
}

// 
// 
$("#praddress_incollection").keyup(function () {
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(async () => {
        let _data = $(this).val();

        if (_data.length > 1) {
            if (_data.length > 4) {
                // If it's a ZIP (only digits)
                if (/^\d+$/.test(_data)) {
                    try {
                        const response = await fetch(`http://api.zippopotam.us/us/${_data}`);
                        if (!response.ok) throw new Error('ZIP not found');

                        const json = await response.json();
                        const place = json.places[0];
                        const cityState = `${place['place name']}, ${place['state']}`;
                        // console.log("City and State:", cityState);
                        _data = cityState; //  override _data
                    } catch (error) {
                        console.error("Error fetching ZIP info:", error.message);
                        // Still proceed with original _data (numeric ZIP)
                    }
                }
            }

            // Now _data is either updated (e.g. "Austin, Texas") or unchanged (fallback ZIP)
            RateLimiter(() => PostRec(
                'https://geocode.maps.co/search?q=' + encodeURIComponent(_data) + '&format=json&api_key=676595b7f0bd0872036171tno88a01f',
                _data,
                function (_err, ___data) {
                    if (!_err) {
                        $('.store_form').addClass('opened');
                        var addresses_drop = (___data ? get_all_addresses_popup(___data) : []);
                        $('.addresses_drop').html('');

                        // console.log("Address drop: " + addresses_drop.length);

                        if (addresses_drop.length > 0) {
                            for (var _a = 0; _a < addresses_drop.length; _a++) {
                                $('.addresses_drop').addClass('opened').append(
                                    "<li class='l_drop_li_cs' data-id='" + addresses_drop[_a]['id'] + "'  " +
                                    "data-name='" + addresses_drop[_a]['title'].trim() + "' " +
                                    "data-address='" + addresses_drop[_a]['title'].trim() + "' " +
                                    "data-lat='" + addresses_drop[_a]['lat'] + "' data-lng='" + addresses_drop[_a]['lon'] + "'>" +
                                    addresses_drop[_a]['title'] + "</li>"
                                );
                            }
                        } else {
                            // Address not found
                        }
                    } else {
                        console.error("Error fetching geocode data", _err);
                    }
                }
            ));
        }
    }, 300); // Debounce wait time
});
  
     $('body').on('click', '.store_form.opened .form_block button.close_search', function(e){
          e.preventDefault();
          $('.store_form').removeClass('opened');
          $('.addresses_drop').removeClass('opened').html('');
          $('#praddress').val('');
        return false;
      });


  
      $("#praddress_incollection").on('keyup', function () {
      const selectedValue = $('input[name="search_type"]:checked').val();
      var _data = $("#praddress_incollection").val();
      
      if (_data.length > 2) {
        if (selectedValue === 'name') {                    
          $('.store_form').addClass('opened');                    
          searchLocationsNear("", "", _data);                
        }
      }
    });

  function clearLocations() {
	$(".l_map_res_list").empty();
  }

  // var _collection_icons=["https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Seiko5_Black.png?v=1661411997","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/pressage_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/prospex_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215"];

  var _collection_icons = {
    11: "https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/prospex_logo_black.svg?582",
    2: "https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215",
    14: "https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Seiko5_Black.png?v=1661411997",
    12: "https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/pressage_logo_black.svg?582",
  };

  let _isSearching = false; // prevent duplicate requests

  function searchLocationsNear(lat, lng, name, callbackFnk, onlyMap = false) {  
    
  	LoaderShow();
    showLoader();
    $(".list_loader_popup").show();
    clearLocations();
    markers = []; 
    // var searchUrl = 'https://apps-jsa.com/seiko-staging-app/public/api/postrequest';  

    var searchUrl = null;
    if (typeof name !== 'undefined' && name !== null && name !== '') {
      searchUrl = 'https://skus.gatewayforge.io/api/store-locator?search_name=' + name + '&per_page=1';
    } 
    else {
      searchUrl = 'https://skus.gatewayforge.io/api/store-locator?latitude=' + lat + '&longitude=' + lng + '&per_page=1';
    }
   
    var _data={};
 $('.collections_filter_s li').removeClass('active');
    
    // Preserve the original geocode lat/lng
    if (lat && lng) {
      _curr_lat = lat;
      _curr_lng = lng;
    }
    
    PostRec(searchUrl, _data, function(_err, __data){

    if (!__data || !__data.result || !__data.result.data || __data.result.data.length === 0) {        
      $(".list_loader_popup").hide();      
      clearLocations();    
      hideLoader();  
      PopuperShow("Please search another input address to search for locations.");      
      return;
    }

    var ___data = __data.result.data;  
    _allstores_list = ___data;
    COLLECTION_ID_MAP = buildCollectionMap(_allstores_list);
    // console.log('_allstores_list',_allstores_list);

    $('.l_map_wrap_right').css('opacity', '1');              

    var _all_strs = [];

    for (var i = 0; i < ___data.length; i++) {

        var store = ___data[i];
        console.log('store', store);
        console.log('latl', latl);

        var id          = store.id;                     
        var store_name  = store.store_name;                    
        var phone       = store.phone_number;                   
        var site        = store.website;                   
        var address     = store.address;                   
        var city_state  = store.city_state;                   
        var latl        = parseFloat(store.latitude);                   
        var lngl        = parseFloat(store.longitude);     
        
        // Skip store if lat/lng missing or invalid
        if (!store.latitude || !store.longitude || isNaN(latl) || isNaN(lngl)) {
            console.log("Skipping store due to invalid coordinates:", store_name);
            continue;
        }

      var distance    = getDistance(_curr_lat, _curr_lng, latl, lngl).toFixed(1);   
        console.log('lllm');               
        var _collection = GetCollectionIcons(store.collections);

        _all_strs.push({
            id: id,
            store_name: store_name,
            phone: phone,
            address: address,
            city_state: city_state,
            latl: latl,
            lngl: lngl,
            distance: distance,
            i: i,
            collection: _collection,
            site: site
        });
    }

    _all_strs.sort(SortStores);    
    clearLocations();

    // for (var i = 0; i < Math.min(3, _all_strs.length); i++) {
    for (var i = 0; i < _all_strs.length; i++) {

      const storee = _all_strs[i] || {};
      createOption_popup_name(      
        storee.id ?? "",      
        storee.store_name ?? "",      
        storee.address ?? "",      
        storee.latl ?? "",      
        storee.lngl ?? "",      
        storee.distance ?? "",      
        i      
      );

      createMarker(
            storee.id,
            storee.store_name,
            storee.phone,
            storee.address,
            storee.latl,
            storee.lngl,
            i,
            storee.distance,
            storee.site,
            storee.collection
        );
    }

    // $(".l_map_res_list").append(
    //     '<a class="view_more_s" href="/pages/store-locator#' +
    //         _all_strs[0].id + "|" +
    //         _all_strs[0].latl + "|" +
    //         _all_strs[0].lngl +
    //     '">View all results</a>'
    // );

    // var ul_height = $(".find_a_store_opened .l_map_res_list").height();
    // console.log('ul_height', ul_height);

    var ul_height = $(".l_map_res_list").height();

    $(".find_a_store_opened")
        .stop()
        .animate({ height: ul_height + 245 }, 400);

    $(".l_map_wrap_left_scrl")
        .stop()
        .animate({ height: ul_height + 50 }, 400);
    });
}

function buildCollectionMap(allStores) {
  const map = {};

  // UI collections
  const uiCollections = [];
  $(".collections_filter_s li").each(function(){
    const uiId = $(this).data('id');
    const img = $(this).find('img');
    const title = (img.attr('title') || '').toLowerCase().trim();
    const alt   = (img.attr('alt') || '').toLowerCase().trim();

    uiCollections.push({ uiId, title, alt });
  });

  // API collections (unique)
  const apiCollections = {};
  allStores.forEach(store => {
    (store.collections || []).forEach(col => {
      apiCollections[col.id] = {
        id: col.id,
        title: col.title.toLowerCase(),
        handle: col.handle.toLowerCase()
      };
    });
  });

  // Match UI ↔ API
  uiCollections.forEach(ui => {
    Object.values(apiCollections).forEach(api => {
      if (
        ui.title === api.title ||
        ui.title === api.handle ||
        ui.alt === api.title ||
        ui.alt === api.handle
      ) {
        map[ui.uiId] = api.id;
      }
    });
  });

  return map;
}

function createOption_popup_name(id, store_name, address, lat, lng, distance, i) {

  PopuperClose();
  $(".list_loader_popup").hide();
  $(".store_popup_block h2 span").hide();
  $(".l_map_res_list").append(
    "<li class='l_map_res_list_i' tabindex='0' " +
      "data-id='" + id + "' " +
      "data-marker-index='" + i + "' " +
      "data-name='" + store_name.trim() + "' " +
      "data-address='" + address.trim() + "' " +
      "data-lat='" + lat + "' " +
      "data-lng='" + lng + "'> " +
      
      "<a href='/pages/store-locator#" + id + "|" + lat + "|" + lng + "'>" +
        "<span class='l_map_store_name'>" + store_name.trim() + "</span>" +
        "<p class='l_map_distance'>" + distance + " mi" +
          "<span class='l_map_address'>" +
            (address.trim().split(',').slice(1, 3).join(',').trim()) +
          "</span>" +
        "</p>" +
      "</a>" +
    "</li>"
  );

  hideLoader();

  setTimeout(function() {
        var $items = $(".l_map_res_list .l_map_res_list_i");

        if ($items.length) {
            // remove old selection
            $items.removeClass("selected");

            // select first item
            var $first = $items.first();
            $first.addClass("selected").focus();

            // open marker popup
            var idx = $first.data("marker-index");
            if (markers[idx]) {
                markers[idx].openPopup();
                map.setView(markers[idx].getLatLng(), 14);
            } 

            // scroll into view
            // $(".l_map_wrap_left_scrl").mCustomScrollbar("scrollTo", $first);

            $first[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, 50);
}

$(window).on("load", function () {
    if ($(".l_map_wrap_left_scrl").length) {
        // Enable native vertical scrolling
        $(".l_map_wrap_left_scrl").css({
            "overflow-y": "auto",
            "max-height": "880px", // adjust as needed
            "scroll-behavior": "smooth" // optional: smooth scrolling
        });
    }
});

function GetCollectionIcons(_collections) {

  console.log('_collections 2' , _collections);

  var _res = "";

  if(Array.isArray(_collections) && _collections.length > 0){

    _collections.forEach(function(col){

      var cid = parseInt(col.id);   // important

      var hh = (cid == 3) ? 40 : 20;

      if(_collection_icons[cid]){
        _res += '<img src="' + _collection_icons[cid] +
                '" style="padding-top:0px;width:auto;height:' + hh +
                'px;display:inline-block;margin:5px 12px" />';
      }

    });

  }

  return _res;
}

// function GetCollectionIcons(_collections) {
//   var _res="";
//   if(_collections.length>0){
//     _collections.map(function(_i){
//         if(_i == 1){
//           var hh = 32;
//         }
//         else{
//           var hh = 14;
//         }
//         _res+='<img src="'+_collection_icons[_i]+'" style="padding-top:0px;width:auto;height:'+hh+'px;display:inline-block;margin:5px 12px" />'; 
//     });
//   } 
//   return _res; 
// }
  
function getDistance(lat1,lon1,lat2,lon2) {

  var R = 3963.1676; // Radius of the earth in miles
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in miles
  console.log(lat2, lon2, lat1, lon1);
  console.log('mark1');
  return d;
  
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

function LoaderShow() {
  $('.map_loader').show();
  $('.l_map_wrap_m').hide();
  $('.l_map_wrap_modal').css({'visibility':'visible','opacity':'1'});
}

function LoaderHide() {
  $('.map_loader').hide();	
  $('.l_map_wrap_modal').css({'opacity':'0','visibility':'hidden'});
}

function PopuperShow(test) {
  //$('.map_loader').hide();			
  //$('#modalPop').show();	
  $('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 300, function(){
    if(window.innerWidth > 640){
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '90px' }, 600);	
    }
    else{
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '60px' }, 600);	
    }
  });
}

var fold_height_content = window.innerHeight-$('.header_top').height();
      
        if($('.content').height()<fold_height_content){
          $('.login_container').height(fold_height_content);
        }
        else{
          $('.login_container').css('padding', '40px 0');
        }
      
        if($('.content').height()<fold_height_content){
          $('.error_container').height(fold_height_content);
        }
        else{
        	$('.error_container').css('padding', '40px 0');
        }
		$('.search_page_content').css('min-height', fold_height_content-$('footer').height()-20);


var fold_height = window.innerHeight-$('.header_top').height();		
      
      	if($('.findstore').length){
			
			if(window.innerWidth > 640){
				$('.l_map_wrap_right').css('height', fold_height_content);
				$('.l_map_wrap_left_scrl').css('height', $('.l_map_wrap_right').height()-$('.l_map_wrap_left .store_form').innerHeight() - 60);
			}
			else{
                $('.filter_selection').html('Filter');
				$('.mobile_map_helper').css('height', '220px');
                $('.l_map_wrap_left_scrl').css('height', fold_height - $('.mobile_map_helper').height() - $('.store_form').height() + 40);
			}
			
			
			if(window.innerWidth > 640){
				$('#mapid').css({'height': $('.l_map_wrap_right').height(), 'width': window.innerWidth-$('.l_map_wrap_left').innerWidth()});
			}
			else{
              	$('#mapid_mobile').css({'height': $('.mobile_map_helper').height(), 'width': window.innerWidth});
			}	
		}

    // store locator new code
       $(".filter_selection").on("click", function () {
        const $filter = $(".collections_filter_s");
        const $this = $(this);
        const isOpen = $filter.hasClass("active");
      
        if (!isOpen) {
          $filter
            .addClass("active")
            .css({ display: "block" }) // set display explicitly
            .stop()
            .animate({ height: $filter.get(0).scrollHeight, opacity: "1" }, 300);
          $this.addClass("active").find(".arrow").html("&#9652;"); // ▲
        } else {
          $filter
            .removeClass("active")
            .stop()
            .animate({ height: 0, opacity: "0" }, 300, function () {
              $filter.css({ display: "none" });
            });
          $this.removeClass("active").find(".arrow").html("&#9662;"); // ▼
        }
            });


            var $wrapper = $(".l_map_wrap_left_wrap");
var $loader = $wrapper.find(".l_map_loader");
var $list = $wrapper.find(".l_map_res_list");

// show loader
function showLoader() {
    $loader.show();
    $list.hide();
}

// hide loader
function hideLoader() {
    $loader.hide();
    $list.show();
}

// $(document).ready(function(){

//   $('.collections_filter_s li').each(function(){

//     let uiId = parseInt($(this).data('id'));
//     console.log('uiId', uiId);

//     let realId = COLLECTION_ID_MAP[uiId];
//     console.log('realId', realId);

//     if(realId){
//       _all_filters.push(realId);
//     } else {
//       $(this).hide();   // 👈 now this works
//       console.warn('No mapping for UI filter id:', uiId);
//     }

//   });
// });